import styled from 'styled-components';

export const SelectSeatTabContent = styled.div`
  padding: 1rem 0;
`;

export const TabInnerContent = styled.div`
  display: flex;
  flex-direction: row;

  .boxWrapper {
    margin-right: 2rem;
  }
  .boxHeaders {
    font-size: 1.4rem;
    padding-bottom: 1rem;
  }
`;

export const StepHdrWrap = styled.div`

  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem 0 2rem;
  .stepNumber {
    display: flex;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: medium;
    margin-right: 1rem
    background: #2276e3;
    font-size: 1.7rem;
  }
  .stepHeaderTxt {
    font-weight: bold;
    font-size: 14px
  }

`;
export const StepContentWrap = styled.div`
  display: flex;
  &.stepOneWrap {
    flex-direction: row;
    margin-bottom: 3rem;
  }
  &.stepTwoWrap {
    flex-direction: column;
  }
`;
export const priceTabWrap = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem 0;
  align-items: center;
`;
export const PriceTabs = styled.span`
  background: #eff3f8;
  border-radius: 0.3rem;
  padding: 0.2rem 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0.8rem;
  span {
    font-size: 1.1rem;
    color: #647a97;
  }
  &.active {
    background: #2276e3;
    span {
      color: white;
    }
  }
`;
export const SeatTypeMenu = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 0 0.5rem 0;
  flex-wrap: wrap;
  align-items: center;
`;
export const SeatType = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 2rem;
  margin-bottom: 0.5rem;
  .seatTypeTxt {
    font-size: 1.1rem;
    color: #929292;
    margin-left: 1rem;
  }
`;
export const SeatBox = styled.span`
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.3rem;
  border: 1px solid #979797;

  &.bookedBg {
    background: #d8d8d8;
  }
  &.availableBg {
    background: white;
  }
  &.ladiesBg {
    background: #fa3988;
  }
  &.menBg {
    background: #2276e3;
  }
`;
export const Button = styled.button(
  props => `
    width: 100%;
    color: white;
    text-align: center;
    font-size: 1.4rem;
    font-weight: bold;
    border-radius: 0.5rem;
    padding: 0.8rem 1rem;
    border: 0;
    outline: 0;
    background-color: #ff6d38;
    cursor:pointer;
    font-family:${props.theme.font.fontFamily};
    margin-top: 1rem;
    &.disabledButton{
      background: #e1e1e1;
      cursor: not-allowed;
      pointer-events: none;
      
    }
`,
);

export const FarePrice = styled.div(
  props => `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem 0;
    .selTxt{
      color: #777;
      font-size: 1.2rem;
      padding-bottom:0.5rem;
    }
    .selSeat{
      font-family:${props.theme.font.fontFamily};
      font-size: 1.4rem;
      font-weight: bold
    }
    .totalPriceTxt{
      font-family:${props.theme.font.fontFamily};
      font-size: 2rem;
      font-weight: bold;
      padding-bottom: 1rem
    }
    .strikeoutPrice{
      font-family:${props.theme.font.fontFamily};
      font-size: 2rem;
      color: #777;
      text-decoration: line-through;
      padding-bottom: 1rem;
      padding-right: 0.5rem;
    }
    .asideRight{
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
    }
    .fareLinkTxt{
      
    }
`,
);

export const SelectBoxWrap = styled.div`
  position: relative;
`;

export const SelectDropDown = styled.select`
  border: 1px solid #979797;
  border-radius: 5px;
  min-width: 21rem;
  background: none;
  padding: 1rem;
  margin-bottom: 1.5rem;
`;
export const SelectArrow = styled.div`
  position: absolute;
  left: 19rem;
  top: 1rem;
  z-index: 2;
`;
export const Tick = styled.span`
  font-size: 11px;
  color: #18a160;
  padding-right: 0.5rem;
`;
export const NoSeatCategoryBlock = styled.section`
  width: 388px;
  height: 474px;
  border-radius: 4px;
  border: dashed 1px #647a97;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const BlockTxt = styled.span(
  props => `
    font-size: 1.4rem;
    color: #647a97;
    border-radius: 0.4rem;
    font-family:${props.theme.font.fontFamily};
    font-weight: bold
    padding-left:2rem;
`,
);

export const BusAmenities = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #f7fcfa;
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  .txtContent {
    color: #16a361;
    font-size: 1.1rem;
  }
  .list {
    display: flex;
    flex-direction: row;
    .listTab {
      background-image: linear-gradient(79deg, #00c57e, #18a160);
      color: white;
      font-weight: bold;
      font-size: 1rem;
      padding: 0.25rem 1rem;
      margin-left: 1rem;
      border-radius: 0.2rem;
    }
  }
`;

export const Tooltip = styled.div`
  position:relative;
  color: #2276e3;
  cursor: pointer;
  &:hover .top {
    display:block;
  }
  .top {
    min-width:280px; 
    top:-1rem;
    left:50%;
    transform:translate(-80%, -100%);
    padding:1.5rem 0;
    color:#444444;
    background-color:white;
    border-radius:0.5rem
    position:absolute;
    z-index:99999999;
    box-shadow: 0 0 12px -2px rgba(51, 51, 51, 0.3);
    display: none;
    i {
      position:absolute;
      top:100%;
      left:70%;
      margin-left:-12px;
      width:48px;
      height:24px;
      overflow:hidden;
      
      &:after {
        content:'';
        position:absolute;
        width:20px;
        height:20px;
        left:50%;
        transform:translate(-50%,-50%) rotate(45deg);
        background-color:#FFFFFF;
        box-shadow:0 1px 8px rgba(51, 51, 51, 0.3);
    }
    
  }

  h3{
    color: #777;
    font-size: 1.4rem;
    font-weight: bold;
    padding: 0.5rem 2rem 1rem;
  }
  .priceRow{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    &.priceRowFooter{
      border-top: 1px solid #e5e5e5;
      padding: 1rem 2rem 0;
      align-self: flex-start;
    }
  }
  .priceListWrap{
    padding: 1rem 2rem;
  }
  .totalPrice{
    color: black;
    font-size: 1.8rem;
    font-weight: bold;
    padding-bottom: 0.2rem;
  }
  .discountPrice{
    color: #17a361;
    
  }
  .discountInnerWrap{
    border-left: 1px solid #e5e5e5;
    padding-left: 1rem;
    p{
      padding-top: 0;
    }
  }
  .smallTxt{
    font-size: 0.9rem;
    color: #666;
  }
  
`;

export const SliderArrowRight = styled.button(
  props => `
      width: 2rem;
      height: 2rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      right: 15rem;
      transform: translateY(-50%);
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      margin-top:2rem;
      &:focus{
        box-shadow: none;
        outline: none;
      }
    `,
);

export const SliderArrowLeft = styled.button(
  props => `
      width: 2rem;
      height: 2rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      transform: translateY(-50%);
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      margin-top:2rem;
      &:focus{
        box-shadow: none;
        outline: none;
      }
    `,
);
export const PriceViewWrapper = styled.section(
  props => `
display: flex;
flex-direction: row;
padding: 1rem 0;
align-items: center;
padding-left:2.5rem;
padding-right:2.5rem;
max-width:385px;
`,
);